var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_3720)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9996 22.0004C18.1395 22.0004 14.1996 18.0605 14.1996 13.2004C14.1996 8.34028 18.1395 4.40039 22.9996 4.40039C27.8597 4.40039 31.7996 8.34028 31.7996 13.2004C31.7996 18.0605 27.8597 22.0004 22.9996 22.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59961 38.7754C7.59961 39.2374 7.97233 39.6004 8.44669 39.6004H37.5525C38.0269 39.6004 38.3996 39.2374 38.3996 38.7754C38.3996 31.9444 31.4874 26.4004 22.9996 26.4004C14.5118 26.4004 7.59961 31.9444 7.59961 38.7754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_3720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/Personal.c16737de67bf0f5a4371fc55113001b0.svg";
export { ForwardRef as ReactComponent };